module.exports = __webpack_public_path__ + "static/media/axcess logo_reversed-2.b38f7f4b.svg";